import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Role } from 'src/app/core/models/user-management/role';
import { ImpactService } from 'src/app/core/services/impact/impact.service';
import { ItemIdModel } from 'src/app/core/models/filter-model/item-id-model';
import { ImpactOutcome, ImpactOutcomeRatingInput } from 'src/app/core/models/impact-assessment/impact-outcome';
import { LinkedIdModel } from 'src/app/core/models/impact-assessment/linked-id-model';
import { ImpactAssessment } from './../../../core/models/impact-assessment/impact-assessment';
import { ImpactOutcomeModel } from 'src/app/core/models/impact-assessment/impact-outcome-model';
import { ImpactRatingDetailModel } from 'src/app/core/models/impact-assessment/impact-rating-detail';
import { AlertDialogModel, ToastViewModel } from 'src/app/core/models/view-model';
import { MasterHelper } from 'src/app/core/utilities';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { MatDialog } from '@angular/material/dialog';
import { UserProfile } from 'src/app/core/models/user';


@Component({
  selector: 'app-impact-outcome',
  templateUrl: './impact-outcome.component.html',
  styleUrls: ['./impact-outcome.component.scss']
})
export class ImpactOutcomeComponent implements OnInit {
  @Input()
  impactAssessment!: ImpactAssessment;
  @Input()
  searchedJuris!: ItemIdModel[];
  @Input()
  userAccessToken!: UserProfile;

  ratingDetails: Array<ImpactRatingDetailModel>;
  impactOutcome: ImpactOutcome;
  impactOutcomeResult: Array<ImpactOutcomeModel>;
  impactOutcomeList: Array<ImpactOutcome>;
  currentUserRole: string;
  isActiveBtn = true;
  isLoading = false;
  resultRating = '';
  linkedAssessmentIds: Array<LinkedIdModel>;
  selectedJuris: ItemIdModel[] = [];
  impactOutcomeRatingInput: ImpactOutcomeRatingInput;
  totalRating: number = 0;
  isResetRating: boolean = false;
  ruleType: Array<string> = ['Draft Rule', 'Final Rule', 'Other'];
  impactRatingInfo: number[] = [];
  isLoadingRegulations = false;
  userTemplate!: number;

  //new added for Topic List
  isDeleteAllTopic: boolean = false;
  alertDialogModel!: AlertDialogModel;
  separatorKeysCodes: number[] = [ENTER, COMMA];

  isToastShow = false;
  toastModel: ToastViewModel;
  currentinfoId: number = 0;

  constructor(private impactService: ImpactService, public dialog: MatDialog, private ref: ChangeDetectorRef) {
    this.ratingDetails = [];
    this.impactOutcome = new ImpactOutcome();
    this.impactOutcomeResult = [];
    this.currentUserRole = '';
    this.impactService.detailTabActive = false;
    this.linkedAssessmentIds = [];
    this.impactOutcomeList = [];
    this.impactOutcomeRatingInput = new ImpactOutcomeRatingInput();
    this.toastModel = new ToastViewModel();

  }

  ngOnInit(): void {
    
    this.fetchCurrentUserRole();
    this.userTemplate = this.impactAssessment.templateNo;
    if (this.impactAssessment.previousImpactAsss_Id) {
      this.getLinkedIds();
    }
    this.updateDetails(this.impactAssessment);
    this.fetchRatingDetails();
    if (this.impactAssessment && this.impactAssessment.jurisdiction) {
      this.impactAssessment.jurisdiction.split(',').forEach(juris => {
        this.selectedJuris.push({ id: 0, name: juris });
      });
    }
    this.GetImpactRatingInfo();
    this.currentinfoId = this.impactAssessment.updatedDB_Id;
  }

  fetchCurrentUserRole(): void {
    this.impactService.getCurrentUserRole().subscribe((data: Role) => {
      this.currentUserRole = data.title;
      this.isActiveBtn = this.currentUserRole &&
        (this.currentUserRole === 'Compliance Enterprise' || this.currentUserRole === 'Horizon Scanning SuperUser') ? false : true;
    });
  }

  fetchRatingDetails(): void {
    this.isLoading = true;
    this.impactService.getImpactRatingDetail().subscribe((data: ImpactRatingDetailModel[]) => {
      this.isLoading = false;
      this.ratingDetails = data;
      this.fetchImpactOutcomeRatings();
    });
  }

  fetchImpactOutcomeRatings(): void {
    
    this.isLoading = true;
    this.totalRating = 0;
    if(this.userTemplate==6){
      this.impactService.getImpactOutcomeT6(this.impactAssessment.id).subscribe((data: ImpactOutcomeModel[])=>{
        this.isLoading = false;
        this.impactOutcomeResult = data;
        this.calculateRatings();
        if (this.isResetRating) {
          this.calculateImpactOutComeRating();
          this.isResetRating = false;
        }
      });
    }
    else{
    this.impactService.getImpactOutcome(this.impactAssessment.id).subscribe((data: ImpactOutcomeModel[]) => {
      this.isLoading = false;
      this.impactOutcomeResult = data;
      this.calculateRatings();
      if (this.isResetRating) {
        this.calculateImpactOutComeRating();
        this.isResetRating = false;
      }
    });
  }
  }

  calculateRatings() {
    var countImpactOutcome = this.impactOutcomeResult.length;
    this.ratingDetails.forEach(element => {
      this.impactOutcomeResult.forEach(element2 => {
        if (+element.id === +element2.parentId) {
          element.selectedId = +element2.id;
        }
      });
    });
    if (this.userTemplate == 1 || this.userTemplate==6) {
      this.totalRating = this.impactOutcomeResult.reduce<number>((accumulator, obj) => {
        return accumulator + obj.rating;
      }, 0);
    }

    if (this.userTemplate == 2) {
      if (countImpactOutcome == 0) {
        this.totalRating = 0;
      }
      if (countImpactOutcome > 0) {
        this.totalRating = this.impactOutcomeResult.reduce<number>((accumulator, obj) => {
          return accumulator + obj.rating;
        }, 0);
        this.totalRating = Math.round((this.totalRating) / countImpactOutcome);
      }
    }
  }

  addImpactOutcomes(id: number, dataList: Array<ImpactRatingDetailModel>): void {
        
    const info = dataList.find(a => a.id === +id);
    const parentId = info ? info.parentId : 0;
    if (id > 0 && parentId > 0) {
      this.isActiveBtn = true;
      this.impactOutcome.impactAssessmentId = this.impactAssessment.id;
      this.impactOutcome.impactOutcomeId = id;
      this.impactOutcome.impactOutcomeParentId = parentId;
      if(this.userTemplate==6){
        this.impactService.saveImpactOutcomeT6(this.impactOutcome).subscribe((result: ImpactAssessment) => {
        this.isActiveBtn = false;
        this.saveOnBrowser('_imasd', JSON.stringify(result));
        this.updateDetails(result);
        this.fetchImpactOutcomeRatings();
      });
      }
      else{
      this.impactService.saveImpactOutcome(this.impactOutcome).subscribe((result: ImpactAssessment) => {
        this.isActiveBtn = false;
        this.saveOnBrowser('_imasd', JSON.stringify(result));
        this.updateDetails(result);
        this.fetchImpactOutcomeRatings();
      });
    }
    }
  }

  // addImpactOutcomeRatings(event: any, parentId: number, id: number): void {
  //   if (event.target.checked && id > 0 && parentId > 0) {
  //     this.isActiveBtn = true;
  //     this.impactOutcome.impactAssessmentId = this.impactAssessment.id;
  //     this.impactOutcome.impactOutcomeId = id;
  //     this.impactOutcome.impactOutcomeParentId = parentId;
  //     // this.impactService.saveImpactOutcome(this.impactOutcome).subscribe((result: ImpactAssessment) => {
  //     //   this.isActiveBtn = false;
  //     //   this.saveOnBrowser('_imasd', JSON.stringify(result));
  //     //   this.updateDetails(result);
  //     //   this.fetchImpactOutcomeRatings();
  //     // });
  //   }
  // }
  getImpactOutComeRating(event: any, parentId: number, id: number): void {
    
    this.impactOutcomeRatingInput.Id = id;
    this.impactOutcomeRatingInput.Rating = this.totalRating;
    this.impactService.getImpactOutcomeRating(this.impactOutcomeRatingInput).subscribe((result: ImpactOutcomeModel) => {
      this.isActiveBtn = false;
      result.parentId = parentId;
      result.id = id;
      this.updateImpactOutInput(parentId, id);
      this.updateSelectedImpactOutList(result);
      this.calculateRatings();
      this.calculateImpactOutComeRating();
    });
  }
  updateImpactOutInput(parentId: number, id: number): void {
    const ExistRow = this.impactOutcomeList.find(a => a.impactOutcomeParentId === parentId);
    if (ExistRow) {
      const index = this.impactOutcomeList.findIndex(a => a.impactOutcomeParentId === parentId);
      this.impactOutcomeList[index].impactOutcomeId = id;
    }
    else {
      let newImpactOutcome = new ImpactOutcome();
      newImpactOutcome.impactAssessmentId = this.impactAssessment.id;
      newImpactOutcome.impactOutcomeId = id;
      newImpactOutcome.impactOutcomeParentId = parentId;
      this.impactOutcomeList.push(newImpactOutcome);
    }
  }
  updateSelectedImpactOutList(result: ImpactOutcomeModel) {
    const ExistRow = this.impactOutcomeResult.find(a => a.parentId === result.parentId);
    if (ExistRow) {
      const index = this.impactOutcomeResult.findIndex(a => a.parentId === result.parentId);
      this.impactOutcomeResult[index].id = result.id;
      this.impactOutcomeResult[index].impactValue = result.impactValue;
      this.impactOutcomeResult[index].rating = result.rating;
    }
    else {
      this.impactOutcomeResult.push(result);
    }
  }
  calculateImpactOutComeRating() {
    
    if (this.userTemplate == 1 || this.userTemplate==6) {
      let numArr = this.impactRatingInfo;
      if (this.totalRating < numArr[0]) {
        this.resultRating = "Low";
      }
      else if (this.totalRating >= (numArr[0]) && this.totalRating <= (numArr[1])) {
        this.resultRating = "Medium";
      }
      else if (this.totalRating >= (numArr[1]) && this.totalRating <= (numArr[2])) {
        this.resultRating = "High";
      }
      else if (this.totalRating > (numArr[2])) {
        this.resultRating = "Very High";
      }
    }
    if (this.userTemplate == 2) {
      if (this.totalRating <= 1) {
        this.resultRating = "Very Low";
      }
      else if (this.totalRating <= 2 && this.totalRating > 1) {
        this.resultRating = "Low";
      }
      else if (this.totalRating <= 3 && this.totalRating > 2) {
        this.resultRating = "Medium";
      }
      else if (this.totalRating <= 4 && this.totalRating > 3) {
        this.resultRating = "High";
      }
      else if (this.totalRating > 4) {
        this.resultRating = "Very High";
      }
    }

  }

  selectExists(id: number): number {
    const info = this.impactOutcomeResult.find(a => a.id === +id);
    return info ? info.id : 0;
  }

  //  checkIfExist(parentId: number, id: number):string {
  //   const index = this.impactOutcomeResult.findIndex(a => a.parentId === +parentId && a.id === +id);
  //   return index > -1 ? 'checked' : null;
  // }
  checkIfExist(parentId: number, id: number): boolean {
    const index = this.impactOutcomeResult.findIndex(a => a.parentId === +parentId && a.id === +id);
    return index > -1 ? true : false;
  }

  getLinkedIds(): void {
    this.impactService.getLinkedIds(this.impactAssessment.previousImpactAsss_Id).subscribe((result: LinkedIdModel[]) => {
      this.linkedAssessmentIds = result;
    });
  }

  updateDetails(result: ImpactAssessment): void {
    this.resultRating = result.impactRating;
    this.impactAssessment.ruleType = result.ruleType ? result.ruleType : 'Draft Rule';
  }

  saveOnBrowser(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  fetchFromBrowser(key: string): string|null {
    return localStorage.getItem(key);
  }
  GetImpactRatingInfo() {
    this.impactService.getImpactRatingInfo().subscribe((result: number[]) => {
      this.impactRatingInfo = result;
    });
  }


  alertMessage(type: string, message: string): void {
    if (type === 'success') {
      this.toastModel.Title = 'Success';
      this.toastModel.Type = 'success';
    } else {
      this.toastModel.Title = 'Warning';
      this.toastModel.Type = 'warning';
    }
    this.toastModel.Message = message;
    this.isToastShow = true;
    setTimeout(() => {
      this.isToastShow = false;
    }, 3000);
  }
  saveImpactAssessmentList() {
    let valid = true;
    //if (this.impactOutcomeList.length > 0) {
    this.ratingDetails.forEach(ratingInfo => {
      if (ratingInfo.isRequired == true && ratingInfo.selectedId == -1) {
        valid = false;
        ratingInfo.color = "error";
      }
      else
        ratingInfo.color = '';
    });

    if (valid) {
      this.isActiveBtn = true;
      this.isLoadingRegulations = true;
      if(this.userTemplate==6){
        this.impactService.saveImpactOutcomeListT6(this.impactOutcomeList, this.impactOutcomeResult.length > 0 ? false : true, this.impactAssessment.id).subscribe((result: ImpactAssessment) => {
          this.isActiveBtn = false;
          this.isLoadingRegulations = false;
          this.impactOutcomeList = [];
          this.saveOnBrowser('_imasd', JSON.stringify(result));
          this.alertMessage("success", "Impact assessment rating saved successfully");
        });
      }
      else{
      this.impactService.saveImpactOutcomeList(this.impactOutcomeList, this.impactOutcomeResult.length > 0 ? false : true, this.impactAssessment.id).subscribe((result: ImpactAssessment) => {
        this.isActiveBtn = false;
        this.isLoadingRegulations = false;
        this.impactOutcomeList = [];
        this.saveOnBrowser('_imasd', JSON.stringify(result));
        this.alertMessage("success", "Impact assessment rating saved successfully");
      });
    }
    }
    else {
      this.alertMessage("warning", "Please select all required impact assessment criterion");
    }
    //}
  }
  resetImpactAssesmnent() {
    this.impactOutcomeResult = [];
    this.impactOutcomeList = [];
    this.isActiveBtn = false;
  }


  getContrastYIQ(hex:string) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    if(result == null)return null;
    var r = parseInt(result[1], 16);
    var g = parseInt(result[2], 16);
    var b = parseInt(result[3], 16);
    var yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
    return (yiq >= 150) ? 'black' : 'white';
  }

  sortArray(itemArray: string[]): string[] {
    return MasterHelper.sortArray(itemArray, 'asc');
  }
  getUpdatedDbInfo(id: number) {
    if (this.currentinfoId != id) {
      this.isLoading = true;
      this.impactService.getImpactAssessmentRegulationDetails(id).subscribe((data: ImpactAssessment) => {
        this.impactAssessment.title = data.title;
        this.impactAssessment.description = data.description;
        this.impactAssessment.pubType = data.pubType;
        this.impactAssessment.geography = data.geography;
        this.impactAssessment.regulator = data.regulator;
        this.impactAssessment.updatedDB_Date = data.updatedDB_Date;
        this.impactAssessment.country = data.country;
        this.currentinfoId = id;
        this.isLoading = false;
      });
    }

  }
}
